import type { SVGProps } from 'react';

export const ThemedSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M11.8125 11.8125L9.40714 9.40714M9.40714 9.40714C10.1725 8.64181 10.6458 7.58452 10.6458 6.41667C10.6458 4.08096 8.75237 2.1875 6.41667 2.1875C4.08096 2.1875 2.1875 4.08096 2.1875 6.41667C2.1875 8.75237 4.08096 10.6458 6.41667 10.6458C7.58452 10.6458 8.64181 10.1725 9.40714 9.40714Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThemedChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5.83203 9.33329L7.75289 7.41244C7.98069 7.18463 7.98069 6.81529 7.75289 6.58748L5.83203 4.66663"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThemedCheckboxIcon = ({
  isIndeterminate,
  isChecked,
}: {
  isIndeterminate?: boolean;
  isChecked?: boolean;
}) => {
  if (isIndeterminate) {
    return (
      <svg
        width="14"
        height="14"
        // Tightened viewBox zooms the glyph ~1.55x within the same 14px
        // footprint; the path is centered on (7,7) so it stays centered.
        viewBox="2.5 2.5 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M3.9375 7H10.0625" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    );
  }
  if (isChecked) {
    return (
      <svg
        width="11"
        height="9.3"
        viewBox="0 0 13 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M1.41406 6.41109L4.41406 9.41109L11.4141 1.41109"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </svg>
    );
  }
  return null;
};
